export enum DepartmentTicketPriority {
  Low = 0,
  Medium = 1,
  High = 2,
  Critical = 3,
}

export enum DepartmentTicketStatus {
  Open = 0,
  InProgress = 1,
  WaitingForSender = 2,
  WaitingForReceiver = 3,
  Resolved = 4,
  Closed = 5,
  Cancelled = 6,
}

export interface CreateDepartmentTicketDto {
  title: string;
  description: string;
  senderDepartment: string;
  receiverDepartment: string;
  priority: DepartmentTicketPriority;
  assignedUserId?: string;
  dueDate?: string;
  createdByEmployeeId: string;
}

export interface DepartmentTicketSummaryDto {
  id: string;
  title: string;
  senderDepartment: string;
  receiverDepartment: string;
  priority: DepartmentTicketPriority;
  status: DepartmentTicketStatus;
  createdByUserId: string;
  createdByFullName?: string;
  assignedUserId?: string;
  assignedUserFullName?: string;
  dueDate?: string;
  createdDate: string;
  lastUpdatedDate: string;
}

export interface CreateDepartmentTicketCommentDto {
  message: string;
  authorEmployeeId: string;
}

export interface DepartmentTicketCommentDto {
  id: string;
  authorUserId: string;
  authorEmail?: string;
  authorFullName?: string;
  authorDepartment: string;
  createdDate: string;
  message: string;
}

export interface DepartmentTicketFileDto {
  id: string;
  fileName: string;
  storedFileName?: string;
  contentType?: string;
  size: number;
  uploadedByUserId: string;
  uploadedByFullName?: string;
  uploadedDate: string;
}

export interface DepartmentTicketStatusHistoryDto {
  id: string;
  fromStatus?: DepartmentTicketStatus;
  toStatus: DepartmentTicketStatus;
  changedByUserId: string;
  changedByFullName?: string;
  changedDate: string;
  note?: string;
}

export interface DepartmentTicketDetailsDto extends DepartmentTicketSummaryDto {
  description: string;
  comments: DepartmentTicketCommentDto[];
  files: DepartmentTicketFileDto[];
  statusHistory: DepartmentTicketStatusHistoryDto[];
}
